import React from 'react';
import './InfoCtVideo.css';

const InfoCtVideo = props => {
  const names0 = props.data.names0.map(name0 => (
    <div key={encodeURIComponent(name0[0])} className="name-wrap">
      <h4>{name0[0]}</h4>
      <h5>{name0[1]}</h5>
    </div>
  ));

  const names1 = props.data.names1.map(name1 => (
    <div key={encodeURIComponent(name1[0])} className="name-wrap">
      <h4>{name1[0]}</h4>
      <h5>{name1[1]}</h5>
    </div>
  ));

  return (
    <div id="info-ct-video" className="info-block">
      <h4 className="ict-video-title">{props.data.title}</h4>
      <div className="video-names">{names0}</div>
      <div className="video-names">{names1}</div>
    </div>
  );
};

export default InfoCtVideo;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/ProjectInfo/InfoCtVideo/InfoCtVideo.js